import { defaultSeriesColor } from '../../../common';
import { SelectorType, IBindable, KeyValuePair } from '../../../models';

export class RowConfiguration implements IBindable {
    color: string;
    decimals: number;
    guid: string;
    hasReconciledValue: boolean;
    isAlarmVisible: boolean;
    isBoundIncludehildren: boolean;
    isBoundToGroup: boolean;
    isCommentVisible: boolean;
    isConstraint: boolean;
    isNameVisble: boolean;
    isQuery: boolean;
    isRangeVisible: boolean;
    isTargetVisible: boolean;
    isUnitVisible: boolean;
    link: IDashboardLink;
    originalGuid: string;
    // This should be dynamic and not saved
    queryValueTypes: KeyValuePair<string, string>[];
    selectorType: SelectorType;
    sortOrder: number;
    value: string;

    constructor() {
        this.color = defaultSeriesColor;
        this.isNameVisble = true;
        this.isCommentVisible = true;
        this.isUnitVisible = true;
        this.isTargetVisible = false;
        this.isRangeVisible = false;
        this.value = 'average';
    }
}

export interface IDashboardLink {
    hasLink: boolean;
    dashboardGuid?: string;
    icon?: string;
}